'use strict';

var scroll = {
	mainnav: {
		active: false,
		$this: $('#menu-outer'),
		$header: $('#header'),
		changed: false,
		sticky: false,
		init: function init() {
			if ($('#menu-outer').length > 0) {
				scroll.mainnav.active = true;
			}
		},
		calculation: function calculation(pos) {
			if (scroll.mainnav.active) {
				//console.log(1);
				if (pos.current.top == 0) {
					scroll.mainnav.changed = false;
				} else if (pos.current.top >= 111) {
					scroll.mainnav.changed = true;
					scroll.mainnav.sticky = true;
				} else {
					scroll.mainnav.changed = false;
				}
			}
		},
		animation: function animation() {
			if (scroll.mainnav.active) {
				if (scroll.mainnav.changed) {
					if (scroll.mainnav.sticky) {
						scroll.mainnav.$this.addClass('sticky');
					} else {
						scroll.mainnav.$this.removeClass('sticky');
					}
				} else {
					scroll.mainnav.$this.removeClass('sticky');
				}
			}
		},
		resize: function resize() {
			// ...
		}
	}
};